// extracted by mini-css-extract-plugin
export default {"wrapper":"Graphs_wrapper__P0faw","controls":"Graphs_controls__444H0","graph":"Graphs_graph__M2D7g","graphpadding":"Graphs_graphpadding__WQKdJ"};